/**
 * 指令管理组件
 * zxw
 * 2024-04-06
 */
import { useState, useEffect } from 'react';
import { ConfigProvider, Tabs, Button, Row, Col, Popover, message, Flex } from 'antd';
import {
    EditOutlined,
    DeleteOutlined,
    InfoCircleOutlined,
    PlusOutlined,
} from '@ant-design/icons';
import {
    CommandIcon,
} from '../../incs/Icons';
import $ from 'jquery';
import CNF from '../../incs/Config';
import {
    UjoinParams,
    AddRequestHeaders,
    FormatCommandContent,
    rootReactDom,
} from '../../incs/FunHelper';

import CommandPrivateEntry from './CommandPrivateEntry';
import CommandPublicEntry from './CommandPublicEntry';

/**
 * 删除私有指令组件
 * @param {*} props 
 * @returns 
 */
const DeleteCommandPrivate = (props) => {
    const [delOpen, setDelOpen] = useState(false);
    /**
     * 删除
     */
    const doDelete = (item) => {
        $.ajax({
            url: `${CNF.api}command/privates/${item.key}`,
            headers: AddRequestHeaders(),
            type: 'DELETE',
            success: function (data) {
                if (data.res === 0) {
                    message.success(data.msg, CNF.messageDuration);
                    setTimeout(() => {
                        props.setIsRefresh(true);
                    }, CNF.messageDuration * 1000);
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    return <Popover
        placement="topRight"
        title={<><InfoCircleOutlined
            style={{ color: '#FF904D', marginRight: 5 }} />删除后无法恢复，确认删除该指令吗？</>}
        content={<>
            <div style={{ textAlign: 'right' }}>
                <Button style={{ marginRight: 10 }} onClick={(e) => {
                    setDelOpen(false);
                    e.preventDefault();
                }}>取消</Button>
                <Button danger onClick={(e) => {
                    doDelete(props.item);
                    setDelOpen(false);
                    e.preventDefault();
                }}>确认</Button>
            </div>
        </>}
        open={delOpen}
    >
        <Button type='link' style={{
            width: '100%',
        }}
            onClick={(e) => {
                setDelOpen(true);
                e.preventDefault();
            }} icon={<DeleteOutlined />} />
    </Popover>
}

/**
 * 私有指令项组件
 * @param {*} props 
 * @returns 
 */
const CommandPrivateItem = (props) => {
    const [isHover, setIsHover] = useState(false);

    return <div style={{
        width: '100%',
        margin: '5px -5px',
        height: 30,
        padding: '5px 0 5px 5px',
        borderRadius: 5,
        cursor: 'pointer',
        position: 'relative',
        // color: props.data.key===props.dialogueUlid?'#fff':'#000',
        backgroundColor: isHover ? '#F8F8FA' : '#fff',
    }}
        onMouseEnter={() => { setIsHover(true) }}
        onMouseLeave={() => { setIsHover(false); }}
        onClick={(e) => {
            if (e.target.tagName.toLowerCase() === 'div' || e.target.tagName.toLowerCase() === 'span') {
                props.setMessages(props.item.content);
                props.setIsCommand(false);  //  退出指令调用
                props.setIsHover(false);    //  退出悬浮
                document.getElementById('chat-question-id') && document.getElementById('chat-question-id').focus()
                props.senderRef && props.senderRef.current.focus({ cursor: 'end', });   //  输入框获取焦点
            }
            e.preventDefault();
        }}
    ><div style={{
        width: isHover ? 'calc(100% - 45px)' : '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    }}><span style={{ fontWeight: 'bold' }}>我创建的</span>&nbsp;|&nbsp;{
                props.item.content.replace(/\]/g, '\[').split('\[').map((item, key) => {
                    if (key % 2 === 0) {
                        return item;
                    } else {
                        return FormatCommandContent(item);
                    }
                })
            }</div>
        <div style={{
            position: 'absolute',
            // padding:'0 5px',
            top: 0,
            right: 0,
            height: 30,
            width: 45,
            lineHeight: '30px',
            background: '#F8F8FA',
            display: isHover ? 'block' : 'none',
        }}>
            <Row style={{ textAlign: 'right' }}>
                <Col span={12}>
                    <Button type='link' style={{
                        width: '100%',
                    }}
                        onClick={(e) => {
                            if (e.target.tagName === 'svg') {
                                props.openCommandPrivateEntry(props.item);
                            }
                            e.preventDefault();
                        }} icon={<EditOutlined />} />
                </Col>
                <Col span={12}>
                    <DeleteCommandPrivate item={props.item} setIsRefresh={props.setIsRefresh} />
                </Col>
            </Row>
        </div>
    </div>
}

/**
 * 收藏指令项组件
 * @param {*} props 
 * @returns 
 */
const CommandCollectItem = (props) => {
    const [isHover, setIsHover] = useState(false);

    return <div style={{
        width: '100%',
        margin: '5px -5px',
        height: 30,
        padding: '5px 0 5px 5px',
        borderRadius: 5,
        cursor: 'pointer',
        position: 'relative',
        // color: props.data.key===props.dialogueUlid?'#fff':'#000',
        backgroundColor: isHover ? '#F8F8FA' : '#fff',
    }}
        onMouseEnter={() => { setIsHover(true) }}
        onMouseLeave={() => { setIsHover(false); }}
        onClick={(e) => {
            if (e.target.tagName.toLowerCase() === 'div' || e.target.tagName.toLowerCase() === 'span') {
                props.setMessages(props.item.content);
                props.setIsCommand(false);              //  退出指令调用
                props.setIsHover(false);                //  退出悬浮
                props.setPublicCommandInfo(props.item); //  发送指令信息，用于增加公共指令调用次数
                document.getElementById('chat-question-id') && document.getElementById('chat-question-id').focus()
                props.senderRef && props.senderRef.current.focus({ cursor: 'end', });   //  输入框获取焦点
            }
            e.preventDefault();
        }}
    ><div style={{
        width: isHover ? 'calc(100% - 45px)' : '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    }}><span style={{ fontWeight: 'bold' }}>{props.item.scene}</span>&nbsp;|&nbsp;{
                props.item.content.replace(/\]/g, '\[').split('\[').map((item, key) => {
                    if (key % 2 === 0) {
                        return item;
                    } else {
                        return FormatCommandContent(item);
                    }
                })
            }</div>
    </div>
}

const CommandX = (props) => {
    const [tagKey, setTagKey] = useState('1');  //  标签key值
    const [isRefresh, setIsRefresh] = useState(true);
    const [pageSize, setPageSize] = useState(CNF.pageSize);
    const [commandContentKeys, setCommandContentKeys] = useState(props.commandContentKeys);
    const [commandPrivates, setCommandPrivates] = useState([]); //  我创建的
    const [commandCollects, setCommandCollects] = useState([]); //  我收藏的
    const [scrollHeightPrivate, setScrollHeightPrivate] = useState(0);        //  我创建的滚动条高度
    const [scrollHeightCollect, setScrollHeightCollect] = useState(0);        //  我创建的滚动条高度

    useEffect(() => {
        if (props.commandContentKeys !== commandContentKeys) {
            setCommandContentKeys(props.commandContentKeys);
            setIsRefresh(true);
        }
        if (isRefresh) {
            if (tagKey === '1') {
                getCommandPrivates();
            } else if (tagKey === '2') {
                getCommandCollects();
            }
        }
    }, [props, isRefresh]);

    //  打开创建指令
    const openCommandPrivateEntry = (record) => {
        rootReactDom && rootReactDom.render(
            <CommandPrivateEntry
                isModalOpen={true}
                record={record}
                setIsRefresh={setIsRefresh}
            />);
    }

    //  打开指令仓库
    const openCommandPublicEntry = () => {
        rootReactDom && rootReactDom.render(
            <CommandPublicEntry
                isModalOpen={true}
                setIsRefresh={setIsRefresh}
                senderRef={props.senderRef}
                setMessages={props.setMessages}
                setIsCommand={props.setIsCommand}
                setIsHover={props.setIsHover}
                setPublicCommandInfo={props.setPublicCommandInfo}
            />);
    }

    /**
     * 获取私有指令
     */
    const getCommandPrivates = () => {
        setIsRefresh(false);
        var params = {
            content: commandContentKeys,
            page_size: pageSize,
        }
        $.ajax({
            url: `${CNF.api}command/privates${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        setCommandPrivates(data.dat);
                    } else {
                        setCommandPrivates([]);
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        });
    }

    /**
     * 获取收藏指令
     */
    const getCommandCollects = () => {
        setIsRefresh(false);
        var params = {
            content: commandContentKeys,
            page_size: pageSize,
        }
        $.ajax({
            url: `${CNF.api}command/collects${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        setCommandCollects(data.dat);
                    } else {
                        setCommandCollects([]);
                    }
                } else {
                    message.error(data.msg, CNF.messageDuration);
                }
            }
        });
    }

    const items = [
        {
            key: '1',
            label: '我创建的',
            children: commandPrivates && commandPrivates.length > 0 ?
                <div style={{
                    width: '100%',
                    maxHeight: 180,
                    scrollbarColor: '#d9d9d9 transparent',
                    scrollbarWidth: 'thin',
                    overflowY: 'auto',
                }}
                    onScroll={(e) => {
                        let d = e.target;
                        let clientHeight = d.clientHeight;   //  div高度
                        let _scrollHeight = d.scrollHeight;  //  滚动条高度
                        let scrollTop = d.scrollTop;         //  滚动条离顶部的高度
                        if (scrollTop + clientHeight === _scrollHeight && _scrollHeight > scrollHeightPrivate) {
                            // 设置滚动条高度
                            setScrollHeightPrivate(_scrollHeight);
                            // 调用接口拉数据
                            setPageSize(pageSize + CNF.pageSize);
                            setIsRefresh(true);
                        }
                    }}
                >
                    {
                        commandPrivates.map((item) => {
                            return <CommandPrivateItem
                                key={item.key}
                                item={item}
                                senderRef={props.senderRef}
                                setMessages={props.setMessages}
                                setIsCommand={props.setIsCommand}
                                openCommandPrivateEntry={openCommandPrivateEntry}
                                setIsRefresh={setIsRefresh}
                                setIsHover={props.setIsHover}

                            />
                        })
                    }
                </div>
                :
                <div style={{ textAlign: 'center', }}>
                    <p style={{ margin: 0, fontSize: 18, fontWeight: 'both' }}>暂无指令</p>
                    <p style={{ margin: 0 }}>请点击&nbsp;<Button style={{ padding: 0 }} type='link' onClick={(e) => {
                        openCommandPrivateEntry(null);
                        e.preventDefault();
                    }}>创建指令</Button></p>
                </div>,
        },
        {
            key: '2',
            label: '我收藏的',
            children: commandCollects && commandCollects.length > 0 ?
                <div style={{
                    width: '100%',
                    maxHeight: 180,
                    scrollbarColor: '#d9d9d9 transparent',
                    scrollbarWidth: 'thin',
                    overflowY: 'auto',
                }}
                    onScroll={(e) => {
                        let d = e.target;
                        let clientHeight = d.clientHeight;   //  div高度
                        let _scrollHeight = d.scrollHeight;  //  滚动条高度
                        let scrollTop = d.scrollTop;         //  滚动条离顶部的高度
                        if (scrollTop + clientHeight === _scrollHeight && _scrollHeight > scrollHeightCollect) {
                            //  设置滚动条高度
                            setScrollHeightCollect(_scrollHeight);
                            //  调用接口拉数据
                            setPageSize(pageSize + CNF.pageSize);
                            setIsRefresh(true);
                        }
                    }}
                >
                    {
                        commandCollects.map((item, key) => {
                            return <CommandCollectItem
                                key={key}
                                item={item}
                                senderRef={props.senderRef}
                                setMessages={props.setMessages}
                                setIsCommand={props.setIsCommand}
                                setIsHover={props.setIsHover}
                                setPublicCommandInfo={props.setPublicCommandInfo}

                            />
                        })
                    }
                </div>
                :
                <div style={{ textAlign: 'center', }}>
                    <p style={{ margin: 0, fontSize: 18, fontWeight: 'both' }}>暂无收藏</p>
                    <p style={{ margin: 0 }}>请点击&nbsp;<Button style={{ padding: 0 }} type='link' onClick={(e) => {
                        openCommandPublicEntry();
                        e.preventDefault();
                    }}>指令仓库</Button></p>
                </div>,
        },
    ]
    return <ConfigProvider
        theme={{
            token: {
                colorPrimary: global.THEMECOLOR,
            },
        }}
    >
        <div style={{ position: 'relative' }}>
            <Tabs
                size='small'
                defaultActiveKey='1'
                items={items}
                onChange={(key) => {
                    setTagKey(key);
                    setPageSize(CNF.pageSize);  //  切换标签时分页大小恢复默认 
                    setIsRefresh(true);         //  执行数据刷新  
                }}
            />
            <div style={{ position: 'absolute', top: 0, right: 0 }}>
                <Flex gap='small' justify='right' flex='right'>
                    <Button onClick={(e) => {
                        openCommandPrivateEntry(null);
                        e.preventDefault();
                    }} style={{ padding: '0 5px' }} type='text' icon={<PlusOutlined />}>创建指令</Button>
                    <Button onClick={(e) => {
                        openCommandPublicEntry();
                        e.preventDefault();
                    }} style={{ padding: '0 5px' }} type='text' icon={<CommandIcon />}>指令仓库</Button>
                </Flex>
            </div>
        </div>
    </ConfigProvider>
}

export default CommandX;